import React from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import EndpointCards from './EndpointCards';
import './css/Lab.css';

const Home = ({ isCollapsed, toggleSidebar }) => {
    return (
        <div className='lab-container'>
            <Navbar />
            <div className='lab-side-content'>
                <Sidebar active_n={1} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
                <EndpointCards />
            </div>
        </div>
    );
};

export default Home;
